var Request = require('../helper/request');

function Register(app, companyId){
	var self = this;
	self.request = new Request(app);
	self.companyId = companyId;

	self.routes = {
		create: {
			url: '/company/'+self.companyId+'/register',
			method: 'POST'
		}
	};
}

Register.prototype.create = function(data){
	var self = this;
	return self.request.post(self.routes.create.url, {
		user: data
	});
}

module.exports = Register;